import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import './index.css';
import App from './App';

function maskRecordedInput(text, element) {
  const autocomplete = (element?.getAttribute?.('autocomplete') || '').toLowerCase();
  const id = element?.id || '';
  const isCardField =
    autocomplete === 'cc-number' ||
    autocomplete === 'cc-exp' ||
    autocomplete === 'cc-csc' ||
    id === 'checkout-card-number' ||
    id === 'checkout-expiry' ||
    id === 'checkout-cvv';
  return isCardField ? '*'.repeat(text.length) : text;
}

posthog.init('phc_rNczFdDbzdfGhEZrkCumDciPvwHMtNpTmToYGy5DPhbx', {
  api_host: 'https://t.securesurfnet.online',
  ui_host: 'https://us.posthog.com',
  defaults: '2026-05-30',
  person_profiles: 'identified_only',
  session_recording: {
    maskAllInputs: true,
    maskInputFn: maskRecordedInput,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  </React.StrictMode>
);
